<script>
import ModelCreate from "../models/create-v2";
import FormsModel from "@/components/forms/unload";
import Swal from 'sweetalert2'
import {serialize} from "object-to-formdata";

import SaleOrderService from "@/services/SaleOrderService";
import SuccessModal from "@/router/views/unload/components/modals/SuccessModal.vue";

export default {
  extends: ModelCreate,
  page: {
    title: "Create Unload Orders",
  },
  components: {
    SuccessModal
  },
  props: {
    cardTitle: {
      default() {
        return 'Nota Bongkar'
      }
    },
    resourceRoute: {default: 'purchase_orders'},
    modelVariable: {default: 'purchase_order'},
    form: {
      default() {
        return FormsModel;
      }
    },
    alerts: {
      default: () => {
        return [
          {
            message: 'Pastikan jumlah fiber sudah sesuai!',
            dismissAfter: 10,
          },
        ]
      }
    }
  },
  data() {
    return {
      title: 'Nota Bongkar',
      items: [
        {
          text: 'Nota Bongkar',
          href: "/unload",
        },
        {
          text: this.$t("Create New"),
          href: "/unload/create",
          active: true,
        },
      ],
      successModalShow: false,
      modelId: null,
    }
  },
  methods: {
    store(value) {
      return this.$axios.post(
          '/v2/sale_orders',
          (serialize(SaleOrderService.transformToCreatePayload(value), {indices: true, booleansAsIntegers: true}))
      );
    },
    storeSuccessAlert(something, id) {
      return Swal.fire({
        title: this.$t('Success') + '!',
        text: this.$t(`You've added {something} with id {id}`, {something, id}),
        type: 'success',
        showConfirmButton: false,
        timer: 1500
      })
    },
    handleStore(value) {
      this.storing = true;
      this.store(value)
          .then((response) => {
            localStorage.removeItem('purchase_order')
            this.modelId = response.data.data.id
            this.showSuccessModal()
          })
          .then(() => {
            this.isEditing = false;
          })
          .catch((error) => this.failedAlert(error))
          .finally(() => {
            this.storing = false
          })
    },
    showSuccessModal() {
      this.successModalShow = true
    },
    handleCloseClickSuccessModal() {
      this.successModalShow = false
      this.$router.push({name: 'unload.index'})
    }
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <success-modal
        v-model="successModalShow"
        :name="$t('unloads.singular')"
        :model-id="modelId"
        action="created"
        @close-clicked="handleCloseClickSuccessModal"
    />
        <div class="row">
          <model-create
              class="col-12"
              :loading="loading"
              :storing="storing"
              v-bind="$props"
              v-model="model"
              :errors.sync="errors"
              @back-click="handleBack"
              @store-click="handleStore"
              @model-changed="handleModelChanged"
          >
          </model-create>
    </div>
  </Layout>
</template>
